// extracted by mini-css-extract-plugin
export default {"modalContentWrapper":"MedicalSummaryViewChanges_modalContentWrapper__kEEHN"};